import { faBookOpen } from '@fortawesome/pro-solid-svg-icons';
import { Callout, Text } from '@scale/scaleui-radix';
import { CompassInstructions } from '@scale/compass-ui/components/CardInstructions';
import { useGetRandomConfig } from 'react-scale/corp/views/CorpProjectGroupManager/communication/apiClient';

export const SaveToSnowflakeInstructions = () => {
  const { data: maxRowsPerTableConfig, isLoading: isLoadingMaxRowsPerTable } = useGetRandomConfig({
    randomConfigName: 'snowflake-max-rows-per-table',
  });
  const maxRowsPerTable = maxRowsPerTableConfig?.value ?? 1000000;

  return (
    <CompassInstructions
      header="How to use the Save to Snowflake card"
      storageKey="saveToSnowflakeInstructionsExpanded"
      disableCollapse={true}
      icon={faBookOpen}
    >
      <Callout.Text>
        <Text as="p">
          <div className="text-sm text-gray-600">
            This card will save the previous output to a Snowflake table. Here's how it works:
            <ul className="list-disc ml-6 mt-2">
              <li>You can choose to append or overwrite the table</li>
              <li>If the table does not exist, it will be created</li>
              <li>Tables are saved to scale_prod.public_writable namespace</li>
              <li>Table names and column names will be sanitized</li>
              <li>Row limit per table: {isLoadingMaxRowsPerTable ? maxRowsPerTable : 'None'}</li>
            </ul>
          </div>
        </Text>
      </Callout.Text>
    </CompassInstructions>
  );
};
